import { c as _c } from "react/compiler-runtime";
import { capitalize } from 'lodash-es';
import { memo, useMemo } from 'react';
import type { VaultV2PendingTimelockDecodedData } from '../../types/pendingTimelocks';
import { getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultV2PendingTimelockStyled';
import AdapterItemLink from './AdapterItemLink';
import VaultPendingTimelockHeader from './VaultV2PendingTimelockHeader';
type VaultV2AdapterPendingData = Extract<VaultV2PendingTimelockDecodedData, {
  __typename: 'VaultV2AdapterPendingData';
}>;
interface VaultV2PendingTimelockRemoveAdapterProps {
  decodedData: VaultV2AdapterPendingData;
  functionName: string;
}
const VaultV2PendingTimelockRemoveAdapter = t0 => {
  const $ = _c(13);
  const {
    decodedData,
    functionName
  } = t0;
  let t1;
  if ($[0] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName
    });
    $[0] = functionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    criticality
  } = t1;
  decodedData.adapter?.__typename;
  let t2;
  bb0: {
    if (functionName === "RemoveAdapter") {
      if (decodedData.adapter?.__typename === "MetaMorphoAdapter") {
        t2 = "Remove vault V1 adapter";
        break bb0;
      } else {
        if (decodedData.adapter?.__typename === "MorphoMarketV1Adapter") {
          t2 = "Remove market V1 adapter";
          break bb0;
        } else {
          t2 = "Remove adapter";
          break bb0;
        }
      }
    }
    let t3;
    if ($[2] !== functionName) {
      t3 = capitalize(functionName);
      $[2] = functionName;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = t3;
  }
  const label = t2;
  let t3;
  if ($[4] !== criticality || $[5] !== label) {
    t3 = <VaultPendingTimelockHeader title={label} criticality={criticality} />;
    $[4] = criticality;
    $[5] = label;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-2xs text-foreground">Item</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== decodedData.adapter) {
    t5 = <StyledVaultPendingTimelock.Row>{t4}<span className="text-2xs text-foreground min-w-0"><AdapterItemLink adapter={decodedData.adapter} /></span></StyledVaultPendingTimelock.Row>;
    $[8] = decodedData.adapter;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex flex-col">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default memo(VaultV2PendingTimelockRemoveAdapter);